import { Injectable, signal } from '@angular/core';

type Variant = 'info' | 'warning' | 'error' | 'success' | undefined;

interface ToastMessage {
  message: string;
  variant: Variant;
  duration: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  message = signal<ToastMessage | null>(null);

  success(message: string, duration: number = 3000) {
    this.show(message, 'success', duration);
  }

  waring(message: string, duration: number = 3000) {
    this.show(message, 'warning', duration);
  }

  error(message: string, duration: number = 3000) {
    this.show(message, 'error', duration);
  }

  show(message: string, variant: Variant, duration: number = 3000) {
    this.message.set({ message, variant, duration });
  }

  close() {
    this.message.set(null);
  }
}
